export var FUTURE_LIVE_CARD_TRANSLATION_KEY = 'future-live-card';